<template>
  <label class="form-field block">
    <span
      v-if="fieldLabel"
      class="label block"
    >
      {{fieldLabel}}
    </span>

    <multiselect
      v-model="localSelectedOptions"
      ref="multiSelect"
      openDirection="bottom"
      selectLabel=""
      deselectLabel=""
      :label="label"
      :track-by="trackBy"
      :multiple="true"
      :taggable="true"
      :options="options"
      :close-on-select="false"
      :clear-on-select="false"
      @input="$emit('input', localSelectedOptions)"
      @select="$emit('select', $event)"
      @remove="$emit('remove', $event)"
      @close="closeEventHandler"
    >
      <span slot="caret"></span>
    </multiselect>
  </label>
</template>

<script>
import Multiselect from 'vue-multiselect'
import FormFieldMixin from '@/mixins/FormFieldMixin';

export default {
  name: 'FormFieldMultiSelect',

  components: {
    Multiselect
  },

  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    label: {
      type: String,
      default: 'title'
    },
    trackBy: {
      type: String,
      default: 'name'
    },
    options: {
      type: Array,
      default: () => ([])
    }
  },

  mixins: [
    FormFieldMixin
  ],

  data() {
    return {
      localSelectedOptions: [],
    }
  },

  mounted() {
    this.$refs.multiSelect.isOpen = true
  },

  methods: {
    closeEventHandler() {
      this.$refs.multiSelect.isOpen = true
    },

    onSelect(val) {
      this.$emit('select', val)
    },

    onRemove(val) {
      this.$emit('remove', val)
    }
  },

  computed: {

  },
  watch: {
    value: {
      handler(options) {
        this.localSelectedOptions = [...options]
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

>>> .multiselect--active {
  @apply z-0;
}

>>> .multiselect__content-wrapper {
  @apply static;
}

>>> .multiselect__tags,
>>> .multiselect__content-wrapper{
  @apply border-2;
  border-color: var(--color-medium);
}

>>> .multiselect__tags {
  @apply border-b-0 pl-5;
}

>>> .multiselect__tags .multiselect__input {
  @apply pl-0;
}

>>> .multiselect__content .multiselect__option {
  @apply px-4
}

>>> .multiselect__element .multiselect__option:after {
  background-color: transparent;
  color: rgba(23, 54, 48, 0.50);
  @apply pr-5 font-medium;
}

>>> .multiselect__content-wrapper {
  @apply border-t-0
}

>>> .multiselect__option--selected {
  background-color: rgba(191, 230, 196, 0.50);
  color: rgba(23, 54, 48, 0.50);
  font-weight: 400;
}
>>> .multiselect__tag {
  background-color: #BFE6C4;
  color: #173630;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  padding: 4px 26px 4px 8px;
}
>>> .multiselect__option--highlight,
>>> .multiselect__option--highlight:hover {
  background-color: rgba(191, 230, 196, 0.30);
  color: #173630;
}

>>> .multiselect__tag-icon:after {
  color: #173630 !important;
  font-size: 22px !important;
  font-weight: 400 !important;
  line-height: 24px !important;
}

>>> .multiselect__tag-icon:hover {
  background: inherit;
}

</style>
